import { ChangeDetectionStrategy, Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { TranslocoModule } from '@jsverse/transloco';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'cat-facet-filter',
  templateUrl: './facet-filter.component.html',
  styleUrls: ['./facet-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [MatIconModule, ReactiveFormsModule, MatInputModule, TranslocoModule, MatButtonModule]
})
@UntilDestroy()
export class FacetFilterComponent implements OnInit {
  @Output() valueChange: EventEmitter<string> = new EventEmitter<string>();

  value: UntypedFormControl = new UntypedFormControl('');

  ngOnInit() {
    this.value.valueChanges.pipe(distinctUntilChanged(), debounceTime(300), untilDestroyed(this)).subscribe((value) => {
      this.valueChange.emit(value);
    });
  }

  clear(): void {
    this.value.setValue('');
  }
}
